import React from "react";
import { Link } from "react-router-dom";

import hAbout1Img from "../../assets/Images/home/h-about-1.png";
import infrastructureImg from "../../assets/Images/home/Infrastructure.svg";
import products400Img from "../../assets/Images/home/400.svg";
import yearsExpertiseImg from "../../assets/Images/home/10-Years-Expertise.svg";

export default function YourTrustedHealth() {
  return (
    <section className="w-full bg-white py-16 sm:py-20 lg:py-24 overflow-hidden">

      {/* INLINE CSS */}
      <style>{`
        .gradient-text {
          background: linear-gradient(135deg, #355931 0%, #A4BE2C 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .feature-card {
          transition: all 0.4s ease;
          border: 1px solid rgba(164,190,44,0.08);
        }

        .feature-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 20px 60px rgba(0,0,0,0.08);
        }

        .feature-icon img {
          transition: transform 0.5s ease;
        }

        .feature-card:hover .feature-icon img {
          transform: scale(1.08);
        }

        .building-image img {
          transition: transform 0.7s ease;
        }

        .building-image:hover img {
          transform: scale(1.03);
        }
      `}</style>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* HEADER */}
        <div className="text-center mb-14 lg:mb-20">

          {/* Small Label */}
          <p className="text-[#6B8A1A] tracking-[0.35em] text-[11px] font-semibold mb-4 uppercase">
            YOUR TRUSTED PARTNER
          </p>

          {/* Main Heading */}
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif text-[#355931] leading-tight">
            Your Trusted Health <span className="gradient-text">& Beauty Partner  </span>
           
          </h1>

             {/* Underline */}
            <div
              className="
                w-24
                h-[2px]
                mx-auto
                mt-6
                mb-6
                dw-fade-up
              "
              style={{
                animationDelay: "240ms",
                background:
                  "linear-gradient(90deg, transparent 0%, #355931 30%, #A4BE2C 70%, transparent 100%)",
              }}
            />

          {/* Description */}
          <p className="max-w-3xl mx-auto text-gray-600 text-sm sm:text-base leading-relaxed mb-8 px-2">
            Nutralike is a wellness-focused brand dedicated to creating
            high-quality nutritional and skincare products inspired by nature
            and guided by science. We are committed to enhancing everyday
            health through safe, effective, and sustainably developed
            formulations.
          </p>

          {/* Button */}
          <Link to={"/about-us"}>
            <button
              className="
                cursor-pointer
                font-semibold
                py-3
                px-8
                rounded-full
                border
                border-[#355931]
                bg-[#355931]
                text-white
                hover:bg-transparent
                hover:text-[#355931]
                transition-all
                duration-500
                tracking-[0.15em]
                text-sm
                uppercase
              "
            >
              Know More
            </button>
          </Link>

        </div>

        {/* MAIN GRID */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">

          {/* LEFT SIDE IMAGE */}
          <div className="relative flex justify-center lg:justify-start">

            {/* Main Image */}
            <div className="relative z-10 building-image">

              <img
                src={hAbout1Img}
                alt="Nutralike Building"
                className="
                  w-full
                  max-w-[280px]
                  sm:max-w-[380px]
                  lg:max-w-[500px]
                  object-contain
                "
              />

            </div>

          </div>

          {/* RIGHT SIDE FEATURES */}
          <div className="flex flex-col gap-5 sm:gap-6">

            {/* FEATURE 1 */}
            <div className="feature-card bg-white rounded-[28px] p-5 sm:p-6 flex gap-4 sm:gap-5">

              <div className="feature-icon flex-shrink-0">
                <div className="
                  w-14
                  h-14
                  sm:w-16
                  sm:h-16
                  rounded-2xl
                  bg-[#f8faf7]
                  flex
                  items-center
                  justify-center
                ">
                  <img
                    src={infrastructureImg}
                    alt="Infrastructure"
                    className="w-10 h-10 sm:w-12 sm:h-12 object-contain"
                  />
                </div>
              </div>

              <div>
            <p className="text-xl sm:text-2xl font-serif mb-2 text-[#355931] leading-snug">
                1 LAC SQ.FT + INFRASTRUCTURE
              </p>

                <p className="text-[14px] sm:text-[15px] text-gray-600 leading-relaxed">
                  Modern manufacturing infrastructure designed for scalable,
                  high-efficiency nutraceutical production and innovation.
                </p>
              </div>

            </div>

            {/* FEATURE 2 */}
            <div className="feature-card bg-white rounded-[28px] p-5 sm:p-6 flex gap-4 sm:gap-5">

              <div className="feature-icon flex-shrink-0">
                <div className="
                  w-14
                  h-14
                  sm:w-16
                  sm:h-16
                  rounded-2xl
                  bg-[#f8faf7]
                  flex
                  items-center
                  justify-center
                ">
                  <img
                    src={products400Img}
                    alt="Products"
                    className="w-10 h-10 sm:w-12 sm:h-12 object-contain"
                  />
                </div>
              </div>

              <div>
                <p className="text-xl sm:text-2xl font-serif mb-2 text-[#355931] leading-snug">
                  400+ NUTRACEUTICAL PRODUCTS
                </p>

                <p className="text-[14px] sm:text-[15px] text-gray-600 leading-relaxed">
                  Extensive product portfolio across wellness, sports nutrition,
                  effervescent tablets, gummies, powders, and supplements.
                </p>
              </div>

            </div>

            {/* FEATURE 3 */}
            <div className="feature-card bg-white rounded-[28px] p-5 sm:p-6 flex gap-4 sm:gap-5">

              <div className="feature-icon flex-shrink-0">
                <div className="
                  w-14
                  h-14
                  sm:w-16
                  sm:h-16
                  rounded-2xl
                  bg-[#f8faf7]
                  flex
                  items-center
                  justify-center
                ">
                  <img
                    src={yearsExpertiseImg}
                    alt="Experience"
                    className="w-10 h-10 sm:w-12 sm:h-12 object-contain"
                  />
                </div>
              </div>

              <div>
                <p className="text-xl sm:text-2xl font-serif mb-2 text-[#355931] leading-snug">
                  11+ YEARS EXPERTISE
                </p>

                <p className="text-[14px] sm:text-[15px] text-gray-600 leading-relaxed">
                  More than a decade of expertise in formulation development,
                  manufacturing excellence, and wellness innovation.
                </p>
              </div>

            </div>

          </div>

        </div>

      </div>
    </section>
  );
}